import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "src/Redux/hooks";
import PackageCalenderItem from "./Calender/PackageCalenderItem";
import { Class, slotDataType } from "src/Utils/Types"; // Ensure this type is correctly defined
import PackageSigleClassAppointment from "./PackageSigleClassAppointment";
import SectionHeader from "../../MainUtils/SectionHeader";
import { setSlots, setSlotsEmpty } from "src/Redux/appSlice";

const PackageAppointment = ({
  next,
  prev,
}: {
  next: () => void;
  prev: () => void;
}) => {
  const [step, setStep] = useState<number>(0);
  const [slotDatas, setSlotsData] = useState<slotDataType[]>([]);
  const selectedPackage = useAppSelector(
    (state) => state?.app?.selectedPackage
  );
  const disptach = useAppDispatch();
  const slots = useAppSelector((state) => state?.app?.slots);

  return (
    <div
      style={{
        minHeight: "100vh",
        // overflowY: "scroll",
        position: "relative",
        paddingBottom: "4rem",
      }}
    >
      <SectionHeader
        title={`Appointments ${slots?.length}/${selectedPackage?.days}`}
        isPrev={true}
        prev={() => {
          disptach(setSlotsEmpty());
          prev();
        }}
      />
      {selectedPackage?.services?.map(
        (
          e: Class | string,
          i: number // Explicitly type `e` and `i`
        ) =>
          step === i && (
            <PackageSigleClassAppointment
              key={i}
              step={step}
              setStep={() => setStep(step + 1)}
              prevStep={() => {
                if (step == 0) return;
                setStep(step - 1);
              }}
              classes={e as Class}
              slots={selectedPackage?.days}
              setSlotsData={setSlotsData}
            />
          )
      )}{" "}
      <div className="class-bottom-next bg-white">
        {/* {step > 0 && (
          <button
            onClick={() => {
              if (step == 0) return;
              setStep(step - 1);
            }}
            style={{
              background: "none",
              border: "1px solid #1f0e4e",
              color: "#1f0e4e",
            }}
          >
            Back
          </button>
        )} */}
        <button
          onClick={() => {
            if (
              !selectedPackage?.services ||
              step + 1 >= selectedPackage.services.length ||
              slots?.length +
                slotDatas?.filter((e) => e?.date && e?.time).length >=
                (selectedPackage?.days ?? 0)
            )
              next();
            disptach(setSlots(slotDatas?.filter((e) => e?.date && e?.time)));
            setStep(step + 1);
          }}
          style={{
            color: "white",
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default PackageAppointment;
